const VIEW_ASSESSMENT = 'VIEW_ASSESSMENT'
const ASSESSMENT_DETAILS = 'ASSESSMENT_DETAILS'
const EMPTY_STATE = 'EMPTY_STATE'

export const painchekTranslations = {
  VIEW_ASSESSMENT: 'View in PainChek',
  ASSESSMENT_DETAILS: 'PainChek Assessment Details',
  EMPTY_STATE: 'Nothing to see',
}

export const painchekConstants = {
  VIEW_ASSESSMENT,
  ASSESSMENT_DETAILS,
  EMPTY_STATE,
}
